import { appEnvironment } from "./app.environment";

export const environment = {
  production: false,
  environment: 'dev',
  tmnBackApi: 'https://apiv2-nprd.cloud.bpifrance.fr/dev/nof/trackmanotif/api',
  sso: {
    enabled: true,
    issuer: 'https://authmfamoa.web.bpifrance.fr',
    clientId: 'HmtHAV8Ssv7fTT5ViY2O',
    discoveryDocumentEndpoint: 'mga/sps/oauth/oauth20/metadata/OIDCP_All-Prof_MFA',
    tokenType: 'access_token'
  },
  appEnvironment
};